import './index.css'
interface TermsOfServiceProps {
  onBack?: () => void
}

export default function TermsOfService({ onBack }: TermsOfServiceProps) {
  return (
    <div className="bc-legal-page">
      <div className="bc-legal-container">
        <button className="bc-legal-back" onClick={onBack ?? (() => window.history.back())}>
          ← Voltar
        </button>

        <h1 className="bc-legal-title">Termos de Uso</h1>
        <p className="bc-legal-date">Vigência: 16 de maio de 2026</p>

        <section className="bc-legal-section">
          <h2>1. Aceitação</h2>
          <p>
            Ao criar uma conta no BagCash, você declara ter lido, compreendido e concordado com
            estes Termos de Uso e com nossa{' '}
            <a href="/privacidade">Política de Privacidade</a>, em conformidade com o
            Art. 7, inciso I, da LGPD (Lei 13.709/2018).
          </p>
          <p>
            Se você não concordar com estes termos, não crie uma conta nem utilize o serviço.
          </p>
        </section>

        <section className="bc-legal-section">
          <h2>2. O serviço</h2>
          <p>
            O BagCash é um aplicativo de gestão financeira pessoal que permite registrar transações,
            monitorar gastos por categoria, controlar cartões de crédito e visualizar relatórios
            financeiros. O serviço é fornecido "no estado em que se encontra" pelo
            desenvolvedor <strong>Paulo Santos</strong> ("BagCash").
          </p>
          <p>
            O BagCash é uma ferramenta de organização pessoal e <strong>não constitui</strong> serviço
            de consultoria financeira, assessoria de investimentos ou qualquer atividade regulada
            pelo Banco Central do Brasil ou pela CVM.
          </p>
        </section>

        <section className="bc-legal-section">
          <h2>3. Elegibilidade e conta</h2>
          <ul>
            <li>Você deve ter pelo menos 18 anos para criar uma conta.</li>
            <li>Você é responsável pela segurança de sua senha e por toda atividade realizada em sua conta.</li>
            <li>É proibido criar contas falsas, usar dados de terceiros ou compartilhar credenciais.</li>
            <li>Cada conta está associada a um "household" (domicílio financeiro). No plano Casal, dois usuários podem compartilhar o mesmo household.</li>
          </ul>
        </section>

        <section className="bc-legal-section">
          <h2>4. Planos e cobrança</h2>
          <table className="bc-legal-table">
            <thead>
              <tr>
                <th>Plano</th>
                <th>Preço mensal</th>
                <th>Preço anual</th>
                <th>Recursos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Free</td>
                <td>Gratuito</td>
                <td>Gratuito</td>
                <td>Funcionalidades básicas, sem cartões extras</td>
              </tr>
              <tr>
                <td>Pro Individual</td>
                <td>R$ 19,90/mês</td>
                <td>R$ 179,90/ano</td>
                <td>Todas as funcionalidades, 1 usuário</td>
              </tr>
              <tr>
                <td>Pro Casal</td>
                <td>R$ 29,90/mês</td>
                <td>R$ 269,90/ano</td>
                <td>Todas as funcionalidades, 2 usuários</td>
              </tr>
            </tbody>
          </table>
          <ul>
            <li>As cobranças são processadas pelo Mercado Pago por meio de débito automático (pré-aprovação).</li>
            <li>Assinaturas mensais renovam todo mês; anuais renovam após 12 parcelas.</li>
            <li>O cancelamento pode ser feito a qualquer momento em Configurações → Assinatura. O acesso pago permanece ativo até o fim do período já pago.</li>
            <li>Não há reembolso de períodos parciais já cobrados, exceto por falha técnica imputável ao BagCash.</li>
            <li>Os preços podem ser reajustados com aviso prévio de 30 dias por e-mail.</li>
          </ul>
        </section>

        <section className="bc-legal-section">
          <h2>5. Uso aceitável</h2>
          <p>É proibido:</p>
          <ul>
            <li>Usar o serviço para fins ilegais ou fraudulentos.</li>
            <li>Tentar acessar dados de outros usuários ou contornar os controles de segurança.</li>
            <li>Realizar engenharia reversa, descompilar ou modificar o aplicativo.</li>
            <li>Sobrecarregar intencionalmente a infraestrutura do serviço.</li>
            <li>Inserir dados falsos com o intuito de prejudicar terceiros.</li>
          </ul>
        </section>

        <section className="bc-legal-section">
          <h2>6. Seus dados</h2>
          <p>
            Você é o titular e responsável pelos dados financeiros que insere no BagCash. O BagCash
            apenas armazena e processa essas informações para prestar o serviço contratado, conforme
            detalhado na <a href="/privacidade">Política de Privacidade</a>.
          </p>
          <p>
            Ao excluir sua conta, todos os seus dados financeiros são removidos permanentemente dos
            nossos sistemas, ressalvados os registros de pagamento que precisam ser mantidos por
            obrigação legal (anonimizados).
          </p>
        </section>

        <section className="bc-legal-section">
          <h2>7. Disponibilidade e limitação de responsabilidade</h2>
          <p>
            O BagCash é disponibilizado sem garantia de disponibilidade ininterrupta. Podemos
            realizar manutenções programadas com aviso prévio razoável.
          </p>
          <p>
            O BagCash não se responsabiliza por decisões financeiras tomadas com base nas
            informações exibidas no aplicativo, por erros de inserção de dados pelo usuário,
            por indisponibilidade de serviços de terceiros (Supabase, Mercado Pago), ou por danos
            indiretos, incidentais ou consequenciais.
          </p>
          <p>
            Nossa responsabilidade total está limitada ao valor pago pelo usuário nos últimos
            3 (três) meses de assinatura.
          </p>
        </section>

        <section className="bc-legal-section">
          <h2>8. Encerramento</h2>
          <p>
            Você pode encerrar sua conta a qualquer momento em Configurações → Excluir conta.
            Podemos suspender ou encerrar contas que violem estes Termos, com aviso prévio sempre
            que possível.
          </p>
        </section>

        <section className="bc-legal-section">
          <h2>9. Alterações nos termos</h2>
          <p>
            Podemos atualizar estes Termos com aviso prévio de 15 dias por e-mail. O uso contínuo
            do serviço após esse prazo constitui aceitação dos novos termos.
          </p>
        </section>

        <section className="bc-legal-section">
          <h2>10. Lei aplicável</h2>
          <p>
            Estes Termos são regidos pela legislação brasileira, incluindo o Código de Defesa do
            Consumidor (Lei 8.078/1990) e a LGPD (Lei 13.709/2018). Fica eleito o foro da
            Comarca de São Paulo/SP para dirimir eventuais disputas.
          </p>
        </section>

        <div className="bc-legal-contact">
          <p>Dúvidas? Fale conosco: <a href="mailto:privacidade@bagcash.app">privacidade@bagcash.app</a></p>
        </div>
      </div>
    </div>
  )
}
